import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { PreferredCommunicationEnum } from '@pkg/form/common/Favorite'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import { z } from 'zod'
import { SalutationEnum } from './embedded'

export const ContactPersonId = entityId('contactPerson')

export type ContactPersonIdType = typeof ContactPersonId.Type

export const ContactablePersonSchema = z.object({
  salutation: z.enum(SalutationEnum.$.zodEnum()).nullish(),
  title: z.string().nullish(),
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  mobile: z.string().nullish(),
  fax: z.string().nullish(),
  preferredCommunication: z.enum(PreferredCommunicationEnum.$.zodEnum()).nullish(),
})

export type ContactablePerson = z.infer<typeof ContactablePersonSchema>

export const ContactPersonSchema = ContactablePersonSchema.extend({
  id: ContactPersonId.schema,
  ownerId: z.string(),
})

export const ContactPersonRefSchema = z.object({
  id: ContactPersonId.ref,
})

export type ContactPersonRef = z.infer<typeof ContactPersonRefSchema>

export type ContactPerson = z.infer<typeof ContactPersonSchema>

export const ContactTypeEnum = defineEnum({
  default: msg`Standard`,
  recipe: msg`Rezept`,
})
export type ContactType = z.infer<typeof ContactTypeEnum>
